export const GET_COMPASS_CUSTOMERS = 'GET_COMPASS_CUSTOMERS'
export const GET_CUSTOMERS_EXPIRATION_COUNTER = 'GET_CUSTOMERS_EXPIRATION_COUNTER'
export const GET_NON_CUSTOMERS = 'GET_NON_CUSTOMERS'
export const GET_NON_CUSTOMERS_EXPIRATION_COUNTER = 'GET_NON_CUSTOMERS_EXPIRATION_COUNTER'
export const SET_LOADING = 'SET_LOADING'
